export const mutations = {
  setUser (state, payload) {
    // localStorage.setItem("user", JSON.stringify(payload))
    state.user = payload;
  },
  clearUser (state) {
    // localStorage.removeItem("user")
    state.user = null;
  },
  setAuth (state, payload) {
    state.isAuthenticated = payload;
  },
  clearAuth(state) {
    state.isAuthenticated = false;
  },
  setError (state, payload) {
    state.error = payload;
  },
  clearError(state) {
    state.error = null;
  },
  setLoading (state, payload) {
    state.loading = payload;
  },
  setRegistrationInfo(state, payload) {
    state.registrationInfo = payload;
  },
  clearRegistrationInfo(state) {
    state.registrationInfo = null;
  },
  setAccountInfo(state, payload) {
    state.accountInfo = payload;
  },
  clearAccountInfo(state) {
    state.accountInfo = null;
  },
  setIsAuthorized (state, payload) {
    state.isAuthorized = payload;
  },
  clearIsAuthorized(state) {
    state.isAuthorized = false;
  },
  setMerchant(state, payload) {
    state.merchant = payload;
  },
  clearMerchant(state) {
    state.merchant = null;
  }
}